export default __webpack_public_path__ + "static/media/settings.9f88e151.svg";